import React, { forwardRef } from 'react';
import { useSpacing } from '../../api/spacing/useSpacing';
import { pickDataProps, pickAriaProps, pickComponentCommonProps, } from '../../interfaces/commonProps';
import { StyledContainer, StyledImage, StyledLabel } from './Avatar.styles';
export const Avatar = forwardRef(function Avatar({ label, size, src, ...restProps }, ref) {
    const avatarProps = {
        size,
        ref,
        outerSpacing: useSpacing(restProps),
        ...pickComponentCommonProps(restProps),
        ...pickDataProps(restProps),
        ...pickAriaProps(restProps),
    };
    return (React.createElement(StyledContainer, { ...avatarProps },
        src && React.createElement(StyledImage, { src: src, alt: "", role: "presentation" }),
        React.createElement(StyledLabel, { size: size }, label)));
});
//# sourceMappingURL=Avatar.js.map